export const COUNTED_NOTIFICATION_TYPES = {
    COMMENTED_ON_USER_ACTIVITY: 'COMMENTED_ON_USER_ACTIVITY',
    COMMENTED_ON_USER_SEGMENT: 'COMMENTED_ON_USER_SEGMENT',
    LEADERBOARD_EARN_FIRST_PLACE: 'LEADERBOARD_EARN_FIRST_PLACE',
    LEADERBOARD_LOSE_FIRST_PLACE: 'LEADERBOARD_LOSE_FIRST_PLACE',
    FAVORITE_SEGMENT_DELETED: 'FAVORITE_SEGMENT_DELETED',
    FAVORITE_SEGMENT_EDITED: 'FAVORITE_SEGMENT_EDITED',
    GROUP_INVITE: 'GROUP_INVITE',
    MEMBER_REQUEST: 'MEMBER_REQUEST',
    CONNECTION_REQUEST: 'CONNECTION_REQUEST',
    COMMENTED_ON_USER_DAILYSUMMARY: 'COMMENTED_ON_USER_DAILYSUMMARY',
    COMMENTED_ON_USER_AUTOCHALLENGE: 'COMMENTED_ON_USER_AUTOCHALLENGE',
    COMMENTED_ON_ACTIVITY_THREAD: 'COMMENTED_ON_ACTIVITY_THREAD',
    CONNECTION_REQUEST_ACCEPTED: 'CONNECTION_REQUEST_ACCEPTED',
    LIKED_ON_ACTIVITY: 'LIKED_ON_ACTIVITY',
    LIKED_ON_ACTIVITY_COMMENT: 'LIKED_ON_ACTIVITY_COMMENT',
    TAGGED_ON_ACTIVITY_COMMENT: 'TAGGED_ON_ACTIVITY_COMMENT',
    AUTO_CHALLENGE_WINNER: 'AUTO_CHALLENGE_WINNER',
    ALSO_COMMENTED_ON_USER_SEGMENT: 'ALSO_COMMENTED_ON_USER_SEGMENT',
    ALSO_COMMENTED_ON_USER_DAILYSUMMARY: 'ALSO_COMMENTED_ON_USER_DAILYSUMMARY',
    GROUP_NEWS_POST: 'GROUP_NEWS_POST',
    GROUP_ANNOUNCEMENT: 'GROUP_ANNOUNCEMENT',
    COMMENTED_ON_GROUP_NEWS_POST: 'COMMENTED_ON_GROUP_NEWS_POST',
    ALSO_COMMENTED_ON_GROUP_NEWS_POST: 'ALSO_COMMENTED_ON_GROUP_NEWS_POST',
    LIKED_ON_GROUP_POST: 'LIKED_ON_GROUP_POST',
    LIKED_ON_GROUP_POST_COMMENT: 'LIKED_ON_GROUP_POST_COMMENT',
    COMMENTED_ON_GROUP_ACTIVITY: 'COMMENTED_ON_GROUP_ACTIVITY',
    ALSO_COMMENTED_ON_GROUP_ACTIVITY: 'ALSO_COMMENTED_ON_GROUP_ACTIVITY',
    LIKED_ON_GROUP_ACTIVITY: 'LIKED_ON_GROUP_ACTIVITY',
    LIKED_ON_GROUP_ACTIVITY_COMMENT: 'LIKED_ON_GROUP_ACTIVITY_COMMENT',
    GROUP_INVITE_ACCEPTED: 'GROUP_INVITE_ACCEPTED',
    PRIVATE_GROUP_REQUEST_ACCEPTED: 'PRIVATE_GROUP_REQUEST_ACCEPTED',
    WEIGHT_SCALE_INVITE: 'WEIGHT_SCALE_INVITE',
    WEIGHT_SCALE_REMOVED: 'WEIGHT_SCALE_REMOVED',
    WEIGHT_SCALE_MAX_USER: 'WEIGHT_SCALE_MAX_USER',
    INACTIVE_ACTIVITY_TRACKER_USED: 'INACTIVE_ACTIVITY_TRACKER_USED',
    GEAR_MAX_DISTANCE: 'GEAR_MAX_DISTANCE',
    GROUP_CHALLENGE_CREATED: 'GROUP_CHALLENGE_CREATED',
    GROUP_CHALLENGE_START: 'GROUP_CHALLENGE_START',
    GROUP_CHALLENGE_OVER: 'GROUP_CHALLENGE_OVER',
    GROUP_CHALLENGE_BADGE: 'GROUP_CHALLENGE_BADGE',
    ADHOC_CHALLENGE_INVITED: 'ADHOC_CHALLENGE_INVITED',
    ADHOC_CHALLENGE_ACCEPTED: 'ADHOC_CHALLENGE_ACCEPTED',
    ADHOC_CHALLENGE_DECLINED: 'ADHOC_CHALLENGE_DECLINED',
    ADHOC_CHALLENGE_START: 'ADHOC_CHALLENGE_START',
    ADHOC_CHALLENGE_INVITE_WILL_EXPIRE: 'ADHOC_CHALLENGE_INVITE_WILL_EXPIRE',
    ADHOC_CHALLENGE_START_TOMORROW: 'ADHOC_CHALLENGE_START_TOMORROW',
    ADHOC_CHALLENGE_SUMMARY: 'ADHOC_CHALLENGE_SUMMARY',
    CHALLENGE_RANKING_UP: 'CHALLENGE_RANKING_UP',
    CHALLENGE_RANKING_TAKEN: 'CHALLENGE_RANKING_TAKEN',
    CHALLENGE_RANKING_DOWN: 'CHALLENGE_RANKING_DOWN',
    ADHOC_CHALLENGE_ENDING_SOON: 'ADHOC_CHALLENGE_ENDING_SOON',
    ADHOC_CHALLENGE_ENDED: 'ADHOC_CHALLENGE_ENDED',
    ADHOC_CHALLENGE_FIRST_PLACE: 'ADHOC_CHALLENGE_FIRST_PLACE',
    ADHOC_CHALLENGE_NOT_FIRST_PLACE: 'ADHOC_CHALLENGE_NOT_FIRST_PLACE',
    ADHOC_CHALLENGE_ALTERNATE_PRIZE: 'ADHOC_CHALLENGE_ALTERNATE_PRIZE',
    COMMENTED_ON_ADHOC_CHALLENGE: 'COMMENTED_ON_ADHOC_CHALLENGE',
    // VVFJR_ADHOC_CHALLENGE_INVITED: 'VVFJR_ADHOC_CHALLENGE_INVITED', // has no handler in buildCommentMessage of PendingCommentItemView.js, so comment it out
    VVFJR_ADHOC_CHALLENGE_START: 'VVFJR_ADHOC_CHALLENGE_START',
    VVFJR_CHALLENGE_INVITE_WILL_EXPIRE: 'VVFJR_CHALLENGE_INVITE_WILL_EXPIRE',
    VVFJR_ADHOC_CHALLENGE_START_TOMORROW: 'VVFJR_ADHOC_CHALLENGE_START_TOMORROW',
    VVFJR_CHALLENGE_ENDING_SOON: 'VVFJR_CHALLENGE_ENDING_SOON',
    VVFJR_CHALLENGE_END: 'VVFJR_CHALLENGE_END',
    VVFJR_ADHOC_CHALLENGE_FIRST_PLACE: 'VVFJR_ADHOC_CHALLENGE_FIRST_PLACE',
    VVFJR_CHALLENGE_NOT_FIRST_PLACE: 'VVFJR_CHALLENGE_NOT_FIRST_PLACE',
    VVFJR_COMMENTED_ON_CHALLENGE: 'VVFJR_COMMENTED_ON_CHALLENGE',

    // VVFJR_TEAM_CHALLENGE_INVITED: 'VVFJR_TEAM_CHALLENGE_INVITED', // has no handler in buildCommentMessage of PendingCommentItemView.js, so comment it out
    VVFJR_TEAM_CHALLENGE_ACCEPTED: 'VVFJR_TEAM_CHALLENGE_ACCEPTED',
    VVFJR_TEAM_CHALLENGE_DECLINED: 'VVFJR_TEAM_CHALLENGE_DECLINED',
    VVFJR_TEAM_CHALLENGE_START: 'VVFJR_TEAM_CHALLENGE_START',
    VVFJR_TEAM_CHALLENGE_INVITE_WILL_EXPIRE: 'VVFJR_TEAM_CHALLENGE_INVITE_WILL_EXPIRE',
    VVFJR_TEAM_CHALLENGE_START_TOMORROW: 'VVFJR_TEAM_CHALLENGE_START_TOMORROW',
    VVFJR_TEAM_CHALLENGE_SUMMARY: 'VVFJR_TEAM_CHALLENGE_SUMMARY',
    VVFJR_TEAM_CHALLENGE_ENDING_SOON: 'VVFJR_TEAM_CHALLENGE_ENDING_SOON',
    VVFJR_TEAM_CHALLENGE_ENDED: 'VVFJR_TEAM_CHALLENGE_ENDED',
    VVFJR_TEAM_CHALLENGE_FIRST_PLACE: 'VVFJR_TEAM_CHALLENGE_FIRST_PLACE',
    VVFJR_TEAM_CHALLENGE_NOT_FIRST_PLACE: 'VVFJR_TEAM_CHALLENGE_NOT_FIRST_PLACE',
    VVFJR_TEAM_CHALLENGE_ALTERNATE_PRIZE: 'VVFJR_TEAM_CHALLENGE_ALTERNATE_PRIZE',
    VVFJR_COMMENTED_ON_TEAM_CHALLENGE: 'VVFJR_COMMENTED_ON_TEAM_CHALLENGE',
    VVFJR_TEAM_CHALLENGE_END: 'VVFJR_TEAM_CHALLENGE_END',
    VVFJR_TEAM_CHALLENGE_ENDS_IN_A_TIE: 'VVFJR_TEAM_CHALLENGE_ENDS_IN_A_TIE',

    BADGE_START_SINGLE: 'BADGE_START_SINGLE',
    BADGE_START: 'BADGE_START',
    BADGE_START_TODAY_ONLY_SINGLE: 'BADGE_START_TODAY_ONLY_SINGLE',
    BADGE_START_TODAY_ONLY: 'BADGE_START_TODAY_ONLY',
    BADGE_EXPIRE_SINGLE: 'BADGE_EXPIRE_SINGLE',
    BADGE_EXPIRE: 'BADGE_EXPIRE',
    BADGE_EARNED_SINGLE: 'BADGE_EARNED_SINGLE',
    BADGE_EARNED: 'BADGE_EARNED',
    SHAREABLE_DEVICE_ACCEPT: 'SHAREABLE_DEVICE_ACCEPT',
    BADGE_LEVEL_UP: 'BADGE_LEVEL_UP',

    SHAREABLE_EVENT_DELETED: 'SHAREABLE_EVENT_DELETED',
    SHAREABLE_EVENT_COURSE_UPDATED: 'SHAREABLE_EVENT_COURSE_UPDATED',
    SHAREABLE_EVENT_UPDATED: 'SHAREABLE_EVENT_UPDATED',
    SHAREABLE_EVENT_PACEPRO_RECREATE: 'SHAREABLE_EVENT_PACEPRO_RECREATE',
    SHAREABLE_EVENT_POWERGUIDE_RECREATE: 'SHAREABLE_EVENT_POWERGUIDE_RECREATE',
    SHAREABLE_EVENT_POWERGUIDE_REMOVED: 'SHAREABLE_EVENT_POWERGUIDE_REMOVED',
    SHAREABLE_EVENT_PACEPRO_REMOVED: 'SHAREABLE_EVENT_PACEPRO_REMOVED',

    PARTNER_REWARD_EARNED: 'PARTNER_REWARD_EARNED',

    ALL_ACTIVITY_TYPE_PRIVACY_UPDATE_SUCCESS: 'ALL_ACTIVITY_TYPE_PRIVACY_UPDATE_SUCCESS',
    ALL_ACTIVITY_TYPE_PRIVACY_UPDATE_FAILURE: 'ALL_ACTIVITY_TYPE_PRIVACY_UPDATE_FAILURE',
    ACTIVITY_TYPE_PRIVACY_UPDATE_SUCCESS: 'ACTIVITY_TYPE_PRIVACY_UPDATE_SUCCESS',
    ACTIVITY_TYPE_PRIVACY_UPDATE_FAILURE: 'ACTIVITY_TYPE_PRIVACY_UPDATE_FAILURE',

    TRAINING_NEW_PREMIUM_CONTENT: 'TRAINING_NEW_PREMIUM_CONTENT'
};

export const GENERIC_NOTIFICATION_CSS_CLASS = {
    COMMENTED_ON_USER_ACTIVITY: 'comment',
    COMMENTED_ON_USER_SEGMENT: 'comment',
    LEADERBOARD_EARN_FIRST_PLACE: 'comment',
    LEADERBOARD_LOSE_FIRST_PLACE: 'comment',
    FAVORITE_SEGMENT_DELETED: 'comment',
    FAVORITE_SEGMENT_EDITED: 'comment',
    COMMENTED_ON_USER_DAILYSUMMARY: 'comment',
    COMMENTED_ON_USER_AUTOCHALLENGE: 'comment',
    COMMENTED_ON_ACTIVITY_THREAD: 'comment',
    AUTO_CHALLENGE_WINNER: 'comment',
    ALSO_COMMENTED_ON_USER_SEGMENT: 'comment',
    ALSO_COMMENTED_ON_USER_DAILYSUMMARY: 'comment',
    CONNECTION_REQUEST_ACCEPTED: 'comment',
    LIKED_ON_ACTIVITY: 'comment',
    LIKED_ON_ACTIVITY_COMMENT: 'comment',
    TAGGED_ON_ACTIVITY_COMMENT: 'comment',
    GROUP_NEWS_POST: 'group',
    GROUP_ANNOUNCEMENT: 'group',
    COMMENTED_ON_GROUP_NEWS_POST: 'group',
    ALSO_COMMENTED_ON_GROUP_NEWS_POST: 'group',
    LIKED_ON_GROUP_POST: 'group',
    LIKED_ON_GROUP_POST_COMMENT: 'group',
    COMMENTED_ON_GROUP_ACTIVITY: 'group',
    ALSO_COMMENTED_ON_GROUP_ACTIVITY: 'group',
    LIKED_ON_GROUP_ACTIVITY: 'group',
    LIKED_ON_GROUP_ACTIVITY_COMMENT: 'group',
    GROUP_INVITE_ACCEPTED: 'group',
    PRIVATE_GROUP_REQUEST_ACCEPTED: 'group',
    WEIGHT_SCALE_REMOVED: 'scale',
    WEIGHT_SCALE_MAX_USER: 'scale',
    INACTIVE_ACTIVITY_TRACKER_USED: 'system',
    GEAR_MAX_DISTANCE: 'gear',
    GROUP_CHALLENGE_CREATED: 'group',
    GROUP_CHALLENGE_START: 'group',
    GROUP_CHALLENGE_OVER: 'group',
    GROUP_CHALLENGE_BADGE: 'group',

    ADHOC_CHALLENGE_ACCEPTED: 'group',
    ADHOC_CHALLENGE_DECLINED: 'group',
    ADHOC_CHALLENGE_START: 'group',
    ADHOC_CHALLENGE_INVITE_WILL_EXPIRE: 'group',
    ADHOC_CHALLENGE_START_TOMORROW: 'group',
    ADHOC_CHALLENGE_SUMMARY: 'group',
    CHALLENGE_RANKING_UP: 'group',
    CHALLENGE_RANKING_TAKEN: 'group',
    CHALLENGE_RANKING_DOWN: 'group',
    ADHOC_CHALLENGE_ENDING_SOON: 'group',
    ADHOC_CHALLENGE_ENDED: 'group',
    ADHOC_CHALLENGE_FIRST_PLACE: 'group',
    ADHOC_CHALLENGE_NOT_FIRST_PLACE: 'group',
    //ADHOC_CHALLENGE_ALTERNATE_PRIZE: 'group',
    COMMENTED_ON_ADHOC_CHALLENGE: 'group',

    VVFJR_ADHOC_CHALLENGE_START: 'group',
    VVFJR_CHALLENGE_INVITE_WILL_EXPIRE: 'group',
    VVFJR_ADHOC_CHALLENGE_START_TOMORROW: 'group',
    VVFJR_CHALLENGE_ENDING_SOON: 'group',
    VVFJR_CHALLENGE_END: 'group',
    VVFJR_ADHOC_CHALLENGE_FIRST_PLACE: 'group',
    VVFJR_CHALLENGE_NOT_FIRST_PLACE: 'group',
    VVFJR_COMMENTED_ON_CHALLENGE: 'group',

    VVFJR_TEAM_CHALLENGE_ACCEPTED: 'group',
    VVFJR_TEAM_CHALLENGE_DECLINED: 'group',
    VVFJR_TEAM_CHALLENGE_START: 'group',
    VVFJR_TEAM_CHALLENGE_INVITE_WILL_EXPIRE: 'group',
    VVFJR_TEAM_CHALLENGE_START_TOMORROW: 'group',
    VVFJR_TEAM_CHALLENGE_SUMMARY: 'group',
    VVFJR_TEAM_CHALLENGE_ENDING_SOON: 'group',
    VVFJR_TEAM_CHALLENGE_ENDED: 'group',
    VVFJR_TEAM_CHALLENGE_FIRST_PLACE: 'group',
    VVFJR_TEAM_CHALLENGE_NOT_FIRST_PLACE: 'group',
    VVFJR_TEAM_CHALLENGE_ALTERNATE_PRIZE: 'group',
    VVFJR_COMMENTED_ON_TEAM_CHALLENGE: 'group',
    VVFJR_TEAM_CHALLENGE_END: 'group',
    VVFJR_TEAM_CHALLENGE_ENDS_IN_A_TIE: 'group',
    SHAREABLE_DEVICE_ACCEPT: 'group',

    BADGE_START_SINGLE: 'badge',
    BADGE_START: 'badge',
    BADGE_START_TODAY_ONLY_SINGLE: 'badge',
    BADGE_START_TODAY_ONLY: 'badge',
    BADGE_EXPIRE_SINGLE: 'badge',
    BADGE_EXPIRE: 'badge',
    BADGE_EARNED_SINGLE: 'badge',
    BADGE_EARNED: 'badge',
    BADGE_LEVEL_UP: 'badge',

    SHAREABLE_EVENT_DELETED: 'event',
    SHAREABLE_EVENT_COURSE_UPDATED: 'event',
    SHAREABLE_EVENT_UPDATED: 'event',
    SHAREABLE_EVENT_PACEPRO_RECREATE: 'event',
    SHAREABLE_EVENT_POWERGUIDE_RECREATE: 'event',
    SHAREABLE_EVENT_POWERGUIDE_REMOVED: 'event',
    SHAREABLE_EVENT_PACEPRO_REMOVED: 'event',
    PARTNER_REWARD_EARNED: 'badge',

    ALL_ACTIVITY_TYPE_PRIVACY_UPDATE_SUCCESS: 'activity-privacy-update',
    ALL_ACTIVITY_TYPE_PRIVACY_UPDATE_FAILURE: 'activity-privacy-update',
    ACTIVITY_TYPE_PRIVACY_UPDATE_SUCCESS: 'activity-privacy-update',
    ACTIVITY_TYPE_PRIVACY_UPDATE_FAILURE: 'activity-privacy-update',

    TRAINING_NEW_PREMIUM_CONTENT: 'premium-content'
};
